export default {
  accountInfo: {},
  logged: false,
};
